module.exports = __webpack_public_path__ + "img/home_experience——zh.0c91b52f.png";